$(document).ready(function () {
    $(".umbraco-forms-hidden input").each(function () {
        // Add role attribute to hidden inputs for better accessibility
        $(this).attr("inert", "");
    });
});